import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext, useLocation } from "react-router-dom";
import {
  Box,
  Card,
  Divider,
  Heading,
  Tag,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { FaRegFileAlt, FaRegFolderOpen } from "react-icons/fa";
import useAxiosPrivate from "hooks/useAxiosPrivate"; // Ensure this is imported

function Articles() {
  const navigate = useNavigate();
  const location = useLocation();
  const { articleIds } = location.state || {};
  const { articles } = useOutletContext();
  const [filteredArticles, setFilteredArticles] = useState([]);
  const dividerColor = useColorModeValue("#dcdcdc", "#4a5568");
  const cardBg = useColorModeValue("white", "#2d3748");
  const headingColor = useColorModeValue("gray.700", "white");
  const textColor = useColorModeValue("gray.700", "gray.300");
  const hoverBg = useColorModeValue("gray.200", "gray.600");
  const axiosPrivate = useAxiosPrivate(); // Ensure this is called

  useEffect(() => {
    const fetchFilteredArticles = async () => {
      if (articleIds && articleIds.length > 0) {
        try {
          const response = await axiosPrivate.post(
            "/articles/get-articles-by-ids",
            {
              ids: articleIds,
            }
          );
          setFilteredArticles(response.data);
        } catch (err) {
          console.error("Error fetching filtered articles:", err);
        }
      }
    };

    fetchFilteredArticles();
  }, [articleIds, articles]);

  const handleArticleClick = async (item) => {
    navigate(`/landing/knowledgebase/articles/post/${item._id}`, {
      state: {
        articleId: item._id,
      },
    });
  };

  return (
    <Card borderRadius={"4px"} bg={cardBg}>
      <Box>
        <Heading
          size={"md"}
          color={headingColor}
          display={"flex"}
          gap={1}
          alignItems={"center"}
          p={5}
        >
          <FaRegFolderOpen /> Articles
        </Heading>
        <Divider borderColor={dividerColor} />
      </Box>
      {filteredArticles.map((item, i) => (
        <Box key={i}>
          <Box
            p={4}
            _hover={{ cursor: "pointer", bg: hoverBg }}
            onClick={() => handleArticleClick(item)}
          >
            <Heading
              color={headingColor}
              display="flex"
              gap={1}
              alignItems="center"
              size="sm"
            >
              <FaRegFileAlt />
              <Box display="flex" justifyContent="space-between" flex="1">
                <Text
                  whiteSpace="nowrap"
                  overflow="hidden"
                  textOverflow="ellipsis"
                >
                  {item.title.length > 65
                    ? `${item.title.slice(0, 65)}...`
                    : item.title}
                </Text>
                <Box display="flex" gap={1}>
                  {item.tags
                    ? item.tags.slice(0, 3).map((tag, i) => (
                        <Tag key={i} colorScheme="blue" variant="solid">
                          {tag}
                        </Tag>
                      ))
                    : ""}
                </Box>
              </Box>
            </Heading>

            <Text pl={5} color={textColor}>
              {item.summary.length > 100
                ? item.summary.substring(0, 100) + "..."
                : item.summary}
            </Text>
          </Box>
          <Divider borderColor={dividerColor} />
        </Box>
      ))}
    </Card>
  );
}

export default Articles;
